// Entrance animations: one IntersectionObserver adds .is-visible as [data-reveal]
// elements enter the viewport (animate once). A MutationObserver registers any
// [data-reveal] injected later (facets results, recommendations, recently-viewed)
// so AJAX-swapped content is never left stuck at opacity:0. Bails — revealing
// everything (incl. future nodes) — when animations are disabled, reduced motion
// is preferred, or IntersectionObserver is unsupported.
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var active = root.getAttribute("data-anim") === "on" && !reduce && "IntersectionObserver" in window;

  function reveal(el) { el.classList.add("is-visible"); }
  function eachAdded(muts, fn) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        fn(n);
      });
    });
  }

  // Bail path: show everything now and anything added later.
  if (!active) {
    document.querySelectorAll("[data-reveal]").forEach(reveal);
    if ("MutationObserver" in window) {
      new MutationObserver(function (muts) {
        eachAdded(muts, function (n) {
          if (n.matches && n.matches("[data-reveal]")) reveal(n);
          if (n.querySelectorAll) n.querySelectorAll("[data-reveal]").forEach(reveal);
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add("is-visible"); io.unobserve(e.target); }
    });
  }, { rootMargin: "0px 0px -8% 0px", threshold: 0.12 });

  // Stagger: number [data-reveal] children within a group. Capped at 5 (was 8) so
  // the last card in a wide row isn't waiting on a visibly long delay chain.
  var STAGGER_CAP = 5;
  function numberGroup(group) {
    var i = 0;
    group.querySelectorAll("[data-reveal]").forEach(function (el) {
      el.style.setProperty("--reveal-i", Math.min(i, STAGGER_CAP));
      i++;
    });
  }

  document.querySelectorAll("[data-reveal-group]").forEach(numberGroup);
  document.querySelectorAll("[data-reveal]").forEach(function (el) { io.observe(el); });

  // Auto-register [data-reveal] added after load (AJAX swaps).
  if ("MutationObserver" in window) {
    new MutationObserver(function (muts) {
      eachAdded(muts, function (n) {
        if (n.matches && n.matches("[data-reveal-group]")) numberGroup(n);
        if (n.querySelectorAll) n.querySelectorAll("[data-reveal-group]").forEach(numberGroup);
        if (n.matches && n.matches("[data-reveal]")) io.observe(n);
        if (n.querySelectorAll) n.querySelectorAll("[data-reveal]").forEach(function (el) { io.observe(el); });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Safety net: reveal anything above the fold still hidden shortly after load.
  window.addEventListener("load", function () {
    setTimeout(function () {
      document.querySelectorAll("[data-reveal]").forEach(function (el) {
        if (!el.classList.contains("is-visible") && el.getBoundingClientRect().top < window.innerHeight) {
          el.classList.add("is-visible");
        }
      });
    }, 200);
  });
})();
